<eda-dialog2 width="50vw" height="65vh" (apply)="saveValueListSource()" (close)="closeDialog()" [header]="title" >
    <div content class="p-2 space-y-6">
        <div class="col-12 xl:col-4 mb-4">
            <p-dropdown [options]="targetTables" filter="true" optionLabel="label"
            [(ngModel)]="targetTable" [style]="{width:'100%'}"  (onChange)="getColumnsByTable()" 
            i18n-placeholder="@@placeholderTables" placeholder="Tablas" id="targetTable">
        </p-dropdown>
        </div>

        <div class="col-12 xl:col-4 mb-4">
            <p-dropdown [options]="targetCols"  filter="true"
                i18n-placeholder="@@placeholderTargetColumnId" placeholder="Columna con el id"
                [(ngModel)]="targetIdCol" [style]="{width:'100%'}" id="targetIdCol">
            </p-dropdown>
        </div>
        
        <div class="col-12 xl:col-4">
            <p-dropdown [options]="targetCols"  filter="true"
                i18n-placeholder="@@placeholderTargetColumnDesc" placeholder="Columna con la descripción"
                [(ngModel)]="targetDescCol" [style]="{width:'100%'}" id="targetDescCol">
            </p-dropdown>
        </div>
    </div>
</eda-dialog2>